export default __webpack_public_path__ + "static/media/about-people.f9a26036.jpg";